// CSS
import './SearchQueryHistorical.css';
// React hooks
import { useEffect, useState } from 'react';
// Global hooks
import { useAuth } from '../../../../context/AuthContext';
// Skybase hooks
import { API_BASE_URL } from '../../../../config';
// External hooks/components
import { useAuth as useClerkAuth } from '@clerk/react';
import { useMediaQuery } from 'react-responsive';



// =====================
// SearchQueryHistorical – represents the repeater Component displayed on the /history Product page.
// =====================
function SearchQueryHistorical({ 
    id,         // String – the Postgres UUID of the SearchEvent
 }){
    
    // destructure global context
    const { isLoading: isClerkLoading, getToken } = useClerkAuth();
    const { isSubscribed, checkIsSubscribed } = useAuth();

    // responsive CSS
    const isDesktop = useMediaQuery({ minWidth: 1025 });


    // =================
    // SEARCH EVENT JSON
    // =================
    // JSON state var
    const [searchEventJson, setSearchEventJson] = useState(null);
    // onChange ('id', 'isClerkLoading') -> immediately get the Search Event JSON
    useEffect(() => {
        if (isClerkLoading) return;

        const load = async () => {
            const subscribed = await checkIsSubscribed();

            if (!subscribed) {
                console.log("Not subscribed");
                return;
            }

            const token = await getToken();

            if (!token) {
                console.log("No token");
                return;
            }

            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/v1/search/event/${encodeURIComponent(id)}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                const data = await response.json();

                // ⚠️ Developer debugging
                // console.log(`\nSKYBASE (client): SearchQueryHistorical`);
                // console.log(data);

                // update JSON (triggers re-render)
                setSearchEventJson(data);
            } catch (error) {
                console.error(error);
            }
        };

        load();
    }, [isClerkLoading, id, getToken]);

    
    // JSX Component (animated placeholder) – displayed before 'searchEventJSON' !NULL
    if (!searchEventJson) {
        return <div className='SearchQueryHistorical-animated-placeholder'></div>
    }


    // JSX Component
    return(
        <div className='SearchQueryHistorical'>
            
            {/* QueryText */}
            <div className='SearchQueryHistorical-query-text'>"{searchEventJson?.search_query}"</div>

            {/* Right content */}
            { isDesktop &&
                
                <div className='SearchQueryHistorical-right-content'>
                    
                    {/* Date */}
                    <div className='SearchQueryHistorical-query-date'>{new Date(searchEventJson?.created_at).toLocaleDateString("en-US", {month: "long", day: "numeric", year: "numeric" })}</div>

                    {/* Time */}
                    <div className='SearchQueryHistorical-query-time'>{new Date(searchEventJson?.created_at).toLocaleTimeString("en-US", {hour: "numeric", minute: "2-digit", hour12: true, timeZone: "America/New_York"})}</div>

                    {/* Num Results Found */}
                    <div className='SearchQueryHistorical-results-found'>{searchEventJson?.search_results.length} results</div>

                </div>
            }

        </div>
    );
};


// Export statement
export default SearchQueryHistorical;